import React from "react";

const GramsevakPage = () => {
  const officerPhoto = `${process.env.PUBLIC_URL}/images/sachiv.jpeg`;
  const logo = `${process.env.PUBLIC_URL}/images/sj1.jpg`;
  const gpLogo = `${process.env.PUBLIC_URL}/images/gp.jpeg`;

  // Internal CSS Styles
  const styles = {
    pageContainer: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif', // Clean, professional font
      backgroundColor: '#f8f8f8', // Light background
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      borderRadius: '8px',
      lineHeight: '1.6',
    },
    govHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '15px 0',
      borderBottom: '4px solid #0056b3', // Strong line for separation
      marginBottom: '20px',
    },
    govLogo: {
      width: '70px',
      height: '70px',
      objectFit: 'contain',
    },
    gpLogo: {
      width: '80px',
      height: '80px',
      objectFit: 'contain',
    },
    govText: {
      textAlign: 'center',
      flexGrow: 1,
      color: '#0056b3', // Government blue
    },
    govTextH2: {
      margin: '0',
      fontSize: '24px',
      fontWeight: 'bold',
    },
    govTextP: {
      margin: '0',
      fontSize: '14px',
      color: '#333',
    },
    pageTitle: {
      textAlign: 'center',
      fontSize: '28px',
      color: '#d9534f', // A contrasting color for the main title
      fontWeight: '700',
      paddingBottom: '10px',
      borderBottom: '2px dashed #ccc',
      marginBottom: '25px',
    },
    secretaryBox: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      marginBottom: '30px',
      borderLeft: '5px solid #00a65a', // Highlight color
    },
    officerPhoto: {
      width: '120px',
      height: '120px',
      borderRadius: '50%', // Circular photo
      marginRight: '20px',
      border: '4px solid #eee',
      objectFit: 'cover',
    },
    secretaryTitle: {
      color: '#00a65a',
      marginTop: '0',
      marginBottom: '10px',
      borderBottom: '1px solid #eee',
      paddingBottom: '5px',
    },
    secretaryInfoP: {
      margin: '5px 0',
      fontSize: '16px',
    },
    contentBox: {
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    sectionTitle: {
      fontSize: '22px',
      color: '#333',
      borderBottom: '3px solid #f0ad4e', // Yellowish line for secondary titles
      paddingBottom: '5px',
      marginBottom: '15px',
      marginTop: '25px',
    },
    serviceList: {
      listStyleType: 'none',
      paddingLeft: '0',
    },
    serviceListItem: {
      backgroundColor: '#f9f9f9',
      padding: '10px',
      marginBottom: '8px',
      borderRadius: '4px',
      borderLeft: '4px solid #5bc0de', // Light blue highlight
      transition: 'background-color 0.3s',
      fontSize: '16px',
    },
    serviceListItemHover: {
      backgroundColor: '#f0f0f0', // Hover effect (Note: You might need actual CSS/Styled-components for true hover)
    },
    para: {
      marginTop: '30px',
      padding: '15px',
      backgroundColor: '#e6f7ff', // Light blue background for emphasis
      border: '1px solid #cceeff',
      borderRadius: '6px',
      textAlign: 'center',
      fontSize: '18px',
      fontWeight: '500',
      color: '#0056b3',
    }
  };


  return (
    <div style={styles.pageContainer}>

      {/* Maharashtra Govt Header */}
      <div style={styles.govHeader}>
        <img src={logo} alt="Gov Logo" style={styles.govLogo} />
        <div style={styles.govText}>
          <h2 style={styles.govTextH2}>महाराष्ट्र शासन</h2>
          <p style={styles.govTextP}>ग्रामविकास विभाग | जिल्हा परिषद नागपूर</p>
        </div>
        <img src={gpLogo} alt="GP Logo" style={styles.gpLogo} />
      </div>

      <h2 style={styles.pageTitle}>ग्रामपंचायत अधिकारी</h2>

      {/* Secretary Box */}
      <div style={styles.secretaryBox}>
        <img src={officerPhoto} alt="Secretary" style={styles.officerPhoto} />
        <div>
          <h3 style={styles.secretaryTitle}>ग्रामपंचायत अधिकारी माहिती</h3>
          <p style={styles.secretaryInfoP}>
            <b>नाव :</b> वर्षा खोडे
          </p>
          <p style={styles.secretaryInfoP}>
            <b>पद :</b> ग्रामपंचायत अधिकारी
          </p>
          <p style={styles.secretaryInfoP}>
            <b>मोबाईल :</b> 8669393515
          </p>
        </div>
      </div>

      <div style={styles.contentBox}>
        
        <h3 style={styles.sectionTitle}>मुख्य कर्तव्ये</h3>
        <ul style={styles.serviceList}>
          <li style={styles.serviceListItem}>📌 ग्रामसभेचे आयोजन व कार्यवृत्त तयार करणे</li>
          <li style={styles.serviceListItem}>📌 कर वसुली, पाणीपट्टी, स्वच्छता शुल्क</li>
          <li style={styles.serviceListItem}>📌 मनरेगा, स्वच्छ भारत, PMAY योजनांची अंमलबजावणी</li>
          <li style={styles.serviceListItem}>📌 जन्म-मृत्यू, लग्न नोंदणी</li>
          <li style={styles.serviceListItem}>📌 ग्रामपंचायत अभिलेख (नमुना १ ते ३३) ठेवणे</li>
        </ul>

        <h3 style={styles.sectionTitle}>प्रशासनातील भूमिका आणि कार्य</h3>
        <ul style={styles.serviceList}>
          <li style={styles.serviceListItem}>
            <b>📌 प्रशासकीय :</b> शासनाच्या योजना गावापर्यंत पोहोचवणे व अंमलबजावणी
          </li>
          <li style={styles.serviceListItem}>
            <b>📌 नियोजन :</b> ग्रामसभेतील ठरावांचे नियोजन व अंमलबजावणी
          </li>
          <li style={styles.serviceListItem}>
            <b>📌 आर्थिक व्यवस्थापन :</b> करवसुली, अंदाजपत्रक, खर्च व्यवस्थापन
          </li>
          <li style={styles.serviceListItem}>
            <b>📌 अभिलेख :</b> जन्म-मृत्यू/विवाह नोंदी व अभिलेख जतन करणे
          </li>
          <li style={styles.serviceListItem}>
            <b>📌 जनसहाय्य :</b> नागरिकांना प्रमाणपत्रे व शासकीय लाभ मिळवून देणे
          </li>
        </ul>

        <p style={styles.para}>
          आमचा उद्देश हाच आहे की <b>पारदर्शक</b> प्रशासनाद्वारे
          <b>गावाचा सर्वांगीण विकास</b> साधणे.
        </p>

      </div>
    </div>
  );
};

export default GramsevakPage;